import DialogView from './dialog_view';

const Dialog = DialogView;
export default Dialog;
